import React from 'react';
import { Shield, Clock, Lock, MapPin, CheckCircle2, Key } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const FeaturesSection = () => {
  const features = [
    {
      icon: Shield,
      title: 'Secure Facility',
      description: 'Well-maintained secure site with controlled access. Each container fitted with a professional lock box for maximum security.',
      color: 'red',
    },
    {
      icon: Lock,
      title: 'Heavy Duty Lock Included',
      description: 'Industry-standard heavy-duty padlock provided free with every container rental. Keep your belongings safe and secure.',
      color: 'red',
    },
    {
      icon: Clock,
      title: 'Daily Access 7am-7pm',
      description: 'Access your container daily from 7:00 AM to 7:00 PM. Need access outside these hours? Available by prior arrangement.',
      color: 'red',
    },
    {
      icon: CheckCircle2,
      title: '100% Weatherproof',
      description: 'New "one-trip" containers ensure complete protection from weather. Your items stay dry and in perfect condition year-round.',
      color: 'red',
    },
    {
      icon: Key,
      title: 'Fully Concreted Yard',
      description: 'All containers are situated on a fully concreted surface, accessible by car, van, or lorry. Easy loading and unloading in all weather conditions.',
      color: 'red',
    },
    {
      icon: MapPin,
      title: 'Convenient Location',
      description: 'Located at Blackwater Farm in St. Osyth, easily accessible from Clacton-on-Sea and surrounding areas.',
      color: 'red',
    },
  ];

  return (
    <section id="features" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-flex items-center px-4 py-2 rounded-full bg-red-100 text-red-700 text-sm font-medium mb-4">
            <Shield className="h-4 w-4 mr-2" />
            Why Choose Us
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Premium Storage Features
          </h2>
          <p className="text-lg text-gray-600">
            Experience peace of mind with our secure, clean, and accessible storage solutions designed for your convenience.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card
                key={index}
                className="border-2 hover:border-red-200 hover:shadow-xl transition-all duration-300 group relative overflow-hidden"
              >
                <div className="absolute top-0 right-0 w-32 h-32 bg-red-50 rounded-full -mr-16 -mt-16 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <CardContent className="p-8 relative z-10">
                  <div className="w-14 h-14 rounded-xl bg-red-100 flex items-center justify-center mb-5 group-hover:bg-red-600 transition-colors duration-300">
                    <Icon className="h-7 w-7 text-red-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{feature.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom Banner */}
        <div className="mt-16 bg-gradient-to-r from-red-600 to-red-700 rounded-2xl p-8 md:p-12 text-white text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-grid-pattern opacity-10" />
          <div className="relative z-10">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Clean, Secure & Ready for Your Belongings
            </h3>
            <p className="text-lg text-red-100 mb-6 max-w-2xl mx-auto">
              All containers are spotlessly clean, completely weatherproof, and maintained to the highest standards. 
              Your satisfaction and security are our top priorities.
            </p>
            <div className="flex flex-wrap justify-center gap-8 mt-8">
              <div className="text-center">
                <p className="text-4xl font-bold mb-2">New</p>
                <p className="text-red-100">Containers</p>
              </div>
              <div className="h-16 w-px bg-red-400" />
              <div className="text-center">
                <p className="text-4xl font-bold mb-2">Clean</p>
                <p className="text-red-100">& Maintained</p>
              </div>
              <div className="h-16 w-px bg-red-400" />
              <div className="text-center">
                <p className="text-4xl font-bold mb-2">Secure</p>
                <p className="text-red-100">& Protected</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
